import React from "react";
import Link from "next/link";

import { Action, Category } from "constants/events";
import { DispensaryV3 } from "custom-types/DispensariesV3";
import { useEventTracker } from "hooks/useEventTracker";
import { getMerchId } from "utils/eventTracking";

import DispensariesCarousel from "components/DispensariesCarousel";
import NoResults from "components/NoResults";
import TrackImpression from "components/TrackImpression";

const ProductsCbdDispensariesCarousel: React.FC<{ title?: string }> = ({
  title = "Shop CBD stores near you",
}) => {
  const { publishEvent } = useEventTracker();

  const onItemClick = (
    dispensary: Partial<DispensaryV3>,
    merchandisingCampaignId: number | null,
    slot: number,
  ) => {
    const platinumPlacement = !!dispensary.merchandisedCampaigns?.find(
      (campaign) => campaign.unitName === "platinumplacement",
    );

    publishEvent({
      action: Action.click,
      category: Category.productPage,
      dispensaryId: dispensary.id,
      label: platinumPlacement
        ? `cbd carousel card platinum placement - ${slot + 1}`
        : `cbd carousel card - ${slot + 1}`,
      merchandisingCampaignId: merchandisingCampaignId || undefined,
    });
  };

  const trackCardImpression = (slot: number, dispensary: DispensaryV3) => {
    const platinumPlacement = !!dispensary.merchandisedCampaigns?.find(
      (campaign) => campaign.unitName === "platinumplacement",
    );

    const merchandisingCampaignId = getMerchId(dispensary, "platinumplacement");

    publishEvent({
      action: Action.impression,
      category: Category.productPage,
      dispensaryId: dispensary.id,
      label: platinumPlacement
        ? `cbd carousel card platinum placement - ${slot + 1}`
        : `cbd carousel card - ${slot + 1}`,
      merchandisingCampaignId,
    });
  };

  return (
    <TrackImpression
      category={Category.productPage}
      label="cbd carousel"
      className="my-xl md:my-section"
    >
      <DispensariesCarousel
        title={title}
        subtitle="Showing you stores near"
        link="/cbd-stores"
        linkText="See all"
        page="homepage"
        onItemClick={onItemClick}
        changeLocation={true}
        retailType="cbd-store"
        includeDispensaries={false}
        trackCardImpression={trackCardImpression}
        customNoResults={
          <NoResults sectionName="dispensaries">
            <p className="font-bold text-md">
              There are no CBD stores in your area yet.
            </p>
            <p>
              <Link
                href="/cbd-stores"
                className="no-underline font-bold text-green"
              >
                Check out our CBD stores map
              </Link>{" "}
              to find the nearest store outside of your area.
            </p>
          </NoResults>
        }
        impressionOverride={true}
      />
    </TrackImpression>
  );
};

export default ProductsCbdDispensariesCarousel;
